import { stringField, numberField } from 'common/utils/form/fieldTypes';

export default {
  name: stringField({ required: true }),
  iata_code: stringField({ required: true }),
  lat: stringField({ required: false }),
  lon: stringField({ required: false }),
  country: stringField({ required: true }),
  timezone: stringField({ required: false }),
  airport_type: stringField({ required: false }),
  iso_region: stringField({ required: false }),
  elevation: numberField({ required: false })
};
